if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    facetForm.addEventListener('change', (e) => {
      if ((e.target.name === 'filter.v.option.modell' || e.target.name === 'filter.v.option.model') && e.target.checked) {
        document.querySelectorAll(`input[name="${e.target.name}"]`).forEach(cb => {
          if (cb !== e.target) cb.checked = false;
        });
      }

      if (e.target.name === 'filter.v.option.modell' && e.target.checked) {
        document.querySelectorAll('input[name="filter.v.option.farbe"]').forEach(cb => {
          cb.checked = false;
        });
      }
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      if ($('#collection_title').data('handle') == 'iphone-16-pro-max-huelle') {
        var urlParams = {};
        location.search.slice(1).split('&').forEach(item => {
          const arr = item.split('=');
          urlParams[arr[0]] = arr[1] || '';
        });
        if (urlParams.filter_name && urlParams.filter_name != '') {
          searchParams += `&filter_name=${urlParams.filter_name}`;
        }
      }
      if ($('#collection_title').data('handle') == 'iphone-17-pro-max-huelle') {
        var urlParams = {};
        location.search.slice(1).split('&').forEach(item => {
          const arr = item.split('=');
          urlParams[arr[0]] = arr[1] || '';
        });
        if (urlParams.filter_casetype && urlParams.filter_casetype != '') {
          searchParams += `&filter_casetype=${urlParams.filter_casetype}`;
        }
      }
      if ($('#collection_title').data('handle') == 'pitaka-samsung-galaxy-s26-ultra-huelle') {
        var urlParams = {};
        location.search.slice(1).split('&').forEach(item => {
          const arr = item.split('=');
          urlParams[arr[0]] = arr[1] || '';
        });
        if (urlParams.filter_casetype && urlParams.filter_casetype != '') {
          searchParams += `&filter_casetype=${urlParams.filter_casetype}`;
        }
        if (urlParams.filter_name && urlParams.filter_name != '') {
          searchParams += `&filter_name=${urlParams.filter_name}`;
        }
      }
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    console.log('renderSectionFromFetch:网络');
    var params_arr = { 'device': [], 'model': [], 'color': [] };
    const search_arr = url.split('?')[1] != '' ? url.split('?')[1].replaceAll('modell', 'device').replaceAll('farbe', 'color').split('&') : [];
    for (let i = 0; i < search_arr.length; i++) {
      const element = search_arr[i];
      if (element.includes('filter.v.option.device')) {
        params_arr.device.push(element.split('filter.v.option.device=')[1]);
      }
      if (element.includes('filter.v.option.model')) {
        params_arr.model.push(element.split('filter.v.option.model=')[1]);
      }
      if (element.includes('filter.v.option.color')) {
        params_arr.color.push(element.split('filter.v.option.color=')[1]);
      }
    }
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, params_arr);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    console.log('renderSectionFromCache:缓存');
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    const url = FacetFiltersForm.filterData.find(filterDataUrl).url;
    var params_arr = { 'device': [], 'model': [], 'color': [] };
    const filter_arr = url.split('?')[1] != '' ? url.split('?')[1].replaceAll('modell', 'device').replaceAll('farbe', 'color').split('&') : [];
    for (let i = 0; i < filter_arr.length; i++) {
      const element = filter_arr[i];
      if (element.includes('filter.v.option.device')) {
        params_arr.device.push(element.split('filter.v.option.device=')[1]);
      }
      if (element.includes('filter.v.option.model')) {
        params_arr.model.push(element.split('filter.v.option.model=')[1]);
      }
      if (element.includes('filter.v.option.color')) {
        params_arr.color.push(element.split('filter.v.option.color=')[1]);
      }
    }
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html, params_arr);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html, params_data) {
    console.log('renderProductGridContainer');
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const parsedContainer = parsedHTML.getElementById('ProductGridContainer');
    if (!parsedContainer) return;

    // 检查 fetch 返回的 HTML 中是否包含筛选器
    const fetchedFilters = parsedContainer.querySelector('#main-collection-filters');
    const fetchedHasFilters = fetchedFilters && fetchedFilters.querySelectorAll('.js-filter').length > 0;

    if (!fetchedHasFilters) {
      // fetch 返回的 HTML 中没有筛选器，只更新产品网格部分，保留筛选器

      // 保存当前筛选器相关的 DOM 元素
      const currentFiltersAside = document.querySelector('#main-collection-filters');
      const currentFilterColors = document.querySelector('.sticky-filter_colors');
      const currentFilterTypes = document.querySelector('.sticky-filter_types');
      const currentLoadingOverlay = document.querySelector('#ProductGridContainer .loading-overlay');

      // 替换整个 ProductGridContainer
      document.getElementById('ProductGridContainer').innerHTML = parsedContainer.innerHTML;

      // 恢复筛选器元素到 .anchor-facets 中
      if (currentFiltersAside) {
        const newAnchorFacets = document.querySelector('.anchor-facets');
        if (newAnchorFacets) {
          // 移除新 DOM 中的空筛选器容器（避免重复）
          const existingAside = newAnchorFacets.querySelector('#main-collection-filters');
          const existingOverlay = newAnchorFacets.querySelector('.loading-overlay');
          if (existingAside) existingAside.remove();
          if (existingOverlay) existingOverlay.remove();

          // 按原始顺序插入: filter_types 在最前面
          if (currentFilterTypes) newAnchorFacets.insertBefore(currentFilterTypes, newAnchorFacets.firstChild);

          // filter_colors 在 filter_types 后面
          if (currentFilterColors) {
            var colorRef = currentFilterTypes ? currentFilterTypes.nextSibling : newAnchorFacets.firstChild;
            newAnchorFacets.insertBefore(currentFilterColors, colorRef);
          }

          // aside 和 loading-overlay 在最后
          newAnchorFacets.appendChild(currentFiltersAside);
          if (currentLoadingOverlay) newAnchorFacets.appendChild(currentLoadingOverlay);
        } else {
          // fallback: 直接附加到 sticky_container
          const newStickyContainer = document.querySelector('#sticky_container');
          if (newStickyContainer) {
            if (currentFilterTypes) newStickyContainer.appendChild(currentFilterTypes);
            if (currentFilterColors) newStickyContainer.appendChild(currentFilterColors);
            newStickyContainer.appendChild(currentFiltersAside);
            if (currentLoadingOverlay) newStickyContainer.appendChild(currentLoadingOverlay);
          }
        }
      }
    } else {
      // fetch 返回的 HTML 中有筛选器，正常替换
      document.getElementById('ProductGridContainer').innerHTML = parsedContainer.innerHTML;
    }

    const device_visible_option = document.querySelector('.device_visible_option').innerHTML.trim();
    const model_visible_option = document.querySelector('.model_visible_option') ? document.querySelector('.model_visible_option').innerHTML.trim() : '';
    const casetype_visible_option = document.querySelector('.casetype_visible_option').innerHTML.trim();

    const params_device_arr = params_data.device.map((value) => {
      var temp_value = value || '';
      temp_value = temp_value.includes('%2F') ? decodeURI(temp_value).replaceAll('%2F', '/') : temp_value;
      temp_value = temp_value.includes('%27') ? decodeURI(temp_value).replaceAll("%27", "'") : temp_value;
      temp_value = temp_value.includes('%28') ? decodeURI(temp_value).replaceAll('%28', '(') : temp_value;
      temp_value = temp_value.includes('%29') ? decodeURI(temp_value).replaceAll('%29', ')') : temp_value;
      return temp_value;
    });
    const params_model_arr = params_data.model.map((value) => {
      var temp_value = value || '';
      temp_value = temp_value.includes('%2F') ? decodeURI(temp_value).replaceAll('%2F', '/') : temp_value;
      temp_value = temp_value.includes('%27') ? decodeURI(temp_value).replaceAll("%27", "'") : temp_value;
      temp_value = temp_value.includes('%28') ? decodeURI(temp_value).replaceAll('%28', '(') : temp_value;
      temp_value = temp_value.includes('%29') ? decodeURI(temp_value).replaceAll('%29', ')') : temp_value;
      return temp_value;
    });
    const params_color_arr = params_data.color.map((value) => {
      var temp_value = value || '';
      temp_value = temp_value.includes('%2F') ? decodeURI(temp_value).replaceAll('%2F', '/') : temp_value;
      temp_value = temp_value.includes('%28') ? decodeURI(temp_value).replaceAll('%28', '(') : temp_value;
      temp_value = temp_value.includes('%29') ? decodeURI(temp_value).replaceAll('%29', ')') : temp_value;
      temp_value = temp_value.includes('%E2%84%A2') ? decodeURI(temp_value).replaceAll('%E2%84%A2', '™') : temp_value;
      temp_value = temp_value.includes('%7C') ? decodeURI(temp_value).replaceAll('%7C', '|') : temp_value;
      return temp_value;
    });
    var no_filter_params;
    if (params_model_arr.length != 0) {
      no_filter_params = params_model_arr.length == 0 && params_color_arr.length == 0;
    } else {
      no_filter_params = params_device_arr.length == 0 && params_color_arr.length == 0;
    }
    // console.log(no_filter_params);

    var urlParams = {};
    location.search.slice(1).split('&').forEach(item => {
      const arr = item.split('=');
      urlParams[arr[0]] = arr[1] || '';
    });

    var url_color_arr = [], url_param_casetype;
    if (urlParams.filter_name && urlParams.filter_name != '') {

      if (urlParams.filter_name.includes('+')) {
        const url_filter_color_arr = urlParams.filter_name.split('+');
        for (let i = 0; i < url_filter_color_arr.length; i++) {
          url_color_arr.push(url_filter_color_arr[i].replaceAll('-', ' ').replaceAll('%C3%BCber', 'über').replaceAll('milchstra%C3%9Fen', 'milchstraßen'));
        }
      } else {
        url_color_arr.push(urlParams.filter_name.replaceAll('-', ' ').replaceAll('%C3%BCber', 'über').replaceAll('milchstra%C3%9Fen', 'milchstraßen'));
      }
    }
    if (urlParams.filter_casetype && urlParams.filter_casetype != '') {
      url_param_casetype = urlParams.filter_casetype;
    }
    var visible_element_index = 1;
    document.getElementById('ProductGridContainer').querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        if (element.classList.contains('grid__item')) {
          element.classList.add('hidden');
          const color = element.getAttribute('option-color');
          const casetype = element.getAttribute('option-casetype');
          if (element.hasAttribute('option-model')) {
            const model = element.getAttribute('option-model');
            if (model_visible_option != '' && no_filter_params) {
              const option_model = model_visible_option.replaceAll(' ', '+');
              // console.log(option_model)
              if (model.includes(option_model)) {
                element.classList.remove('hidden');
                element.classList.add('scroll-trigger--cancel');
                visible_element_index += 1;
                element.attributeStyleMap.set("--animation-order", visible_element_index);
              }
            } else {
              const model_unavailable = model_visible_option != '' ? !device.includes(model_visible_option.replaceAll(' ', '+')) : (params_model_arr.length > 0 && !params_model_arr.includes(model)); //false
              const color_unavailable = params_color_arr.length > 0 && !params_color_arr.includes(color); //false
              if (model_unavailable || color_unavailable) {
                element.classList.add('hidden');
                element.classList.remove('scroll-trigger--cancel');
              } else {
                element.classList.remove('hidden');
                element.classList.add('scroll-trigger--cancel');
                visible_element_index += 1;
                element.attributeStyleMap.set("--animation-order", visible_element_index);
              }
            }
          }
          if (element.hasAttribute('option-device')) {
            const device = element.getAttribute('option-device');
            if (device_visible_option != '' && no_filter_params) {
              const option_device = device_visible_option.replaceAll(' ', '+');
              // console.log(option_device)
              if (device.includes(option_device)) {
                element.classList.remove('hidden');
                element.classList.add('scroll-trigger--cancel');
                if (casetype.includes('PitaTap')) {
                  visible_element_index = 1;
                } else {
                  visible_element_index += 1;
                }
                element.attributeStyleMap.set("--animation-order", visible_element_index);
              }
            } else if (casetype_visible_option != '' && no_filter_params) {
              const option_casetype = casetype_visible_option.replaceAll(' ', '+');
              // console.log(option_casetype)
              if (color.includes(option_casetype)) {
                element.classList.remove('hidden');
                element.classList.add('scroll-trigger--cancel');
                if (casetype.includes('PitaTap')) {
                  visible_element_index = 1;
                } else {
                  visible_element_index += 1;
                }
                element.attributeStyleMap.set("--animation-order", visible_element_index);
              }
            } else {
              const device_invisible = device_visible_option != '' ? !device.includes(device_visible_option.replaceAll(' ', '+')) : false;
              const device_unavailable = params_device_arr.length > 0 && !params_device_arr.includes(device);
              const casetype_invisible = casetype_visible_option != '' ? !casetype.includes(casetype_visible_option.replaceAll(' ', '+')) : false;
              const color_unavailable = params_color_arr.length > 0 && !params_color_arr.includes(color); //false
              if (device_unavailable || color_unavailable || device_invisible || casetype_invisible) {
                element.classList.add('hidden');
                element.classList.remove('scroll-trigger--cancel');
              } else {
                element.classList.remove('hidden');
                element.classList.remove("order-1");
                element.classList.remove("order-2");
                element.classList.add('scroll-trigger--cancel');
                if (url_color_arr.length > 0 && $('#collection_title').data('handle') == 'pitaka-samsung-galaxy-s26-ultra-huelle' && device == 'Samsung+Galaxy+S26+Ultra') {
                  element.classList.add("order-4");
                  element.attributeStyleMap.set("--animation-order", 4);
                  var shouldPromote_color = false, shouldPromote_casetype = false;
                  // 检查 casetype 匹配
                  if (url_param_casetype && url_param_casetype != '' && casetype == url_param_casetype) {
                    shouldPromote_casetype = true;
                  }
                  // 检查 color 匹配
                  if (url_color_arr.length > 0) {
                    for (let i = 0; i < url_color_arr.length; i++) {
                      const url_filter_color = url_color_arr[i];
                      const option_color = color.replaceAll('+', ' ').split(' | ')[0];
                      if (option_color.includes(url_filter_color)) {
                        shouldPromote_color = true;
                        break;
                      }
                    }
                  }
                  if (shouldPromote_color && shouldPromote_casetype) {
                    element.classList.remove("order-4");
                    element.classList.add("order-1");
                    element.attributeStyleMap.set("--animation-order", 1);
                  } else if (shouldPromote_color) {
                    element.classList.remove("order-4");
                    element.classList.add("order-2");
                    element.attributeStyleMap.set("--animation-order", 2);
                  } else if (shouldPromote_casetype) {
                    element.classList.remove("order-2");
                    element.classList.add("order-3");
                    element.attributeStyleMap.set("--animation-order", 3);
                  }
                } else if (url_color_arr.length > 0 && $('#collection_title').data('handle') == 'iphone-16-pro-max-cases' && device == 'iPhone+16+Pro+Max') {
                  element.classList.add("order-2");
                  element.attributeStyleMap.set("--animation-order", 2);
                  for (let i = 0; i < url_color_arr.length; i++) {
                    const url_filter_color = url_color_arr[i];
                    const option_color = color.replaceAll('+', ' ').split(' | ')[0];
                    // console.log(option_color.includes(url_filter_color))
                    if (option_color.includes(url_filter_color)) {
                      element.classList.remove("order-2");
                      element.classList.add("order-1");
                      element.attributeStyleMap.set("--animation-order", 1);
                      break;
                    }
                  }
                } else if (url_param_casetype != '' && $('#collection_title').data('handle') == 'iphone-17-pro-max-huelle' && device == 'iPhone+17+Pro+Max') {
                  console.log('url_param_casetype', url_param_casetype);
                  console.log('casetype', casetype);
                  element.classList.add("order-2");
                  element.attributeStyleMap.set("--animation-order", 2);
                  if (casetype == url_param_casetype) {
                    element.classList.remove("order-2");
                    element.classList.add("order-1");
                    element.attributeStyleMap.set("--animation-order", 1);
                  }
                } else {
                  // element.classList.add("order-2");
                  element.attributeStyleMap.set("--animation-order", visible_element_index);
                  // if (color.includes('PitaTap')) {
                  //   element.classList.remove("order-2");
                  //   element.classList.add("order-1");
                  //   element.attributeStyleMap.set("--animation-order", 1);
                  // }
                }
              }
            }
          }
        } else {
          element.classList.add('scroll-trigger--cancel');
        }
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );


    // 只在 fetch 返回了筛选器时才移除旧的，避免误删
    if (facetDetailsElementsFromFetch.length > 0) {
      Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
        if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
          currentElement.remove();
        }
      });
    } else {
      // No filters in fetched HTML, keep existing filters in DOM
    }

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        if (elementToRender.id.includes('Details-filter.v.option.color')) {
          var availableCaseTypeList = [];
          // var availableColorList = [];
          elementToRender.querySelectorAll('li.facets__item').forEach(item => {
            const labelClassList = Array.from(item.querySelector('label.facet-checkbox').classList);
            if (!labelClassList.includes('disabled')) {
              // const availableColor = item.getAttribute('data-value').split(' | ')[0];
              // availableColorList.push(availableColor);
              const availableCaseType = item.getAttribute('data-value').split(' | ')[1];
              availableCaseTypeList.push(availableCaseType);
            }
          });
          // availableColorList = [...new Set(availableColorList)];
          availableCaseTypeList = [...new Set(availableCaseTypeList)];
          // console.log(availableColorList)
          // console.log(availableCaseTypeList)
          // if (availableColorList.length > 0) {
          //   document.querySelectorAll('.filter-color-wrapper').forEach(color_wrapper => {
          //     color_wrapper.querySelectorAll('li').forEach(color_li => {
          //       const li_color = color_li.getAttribute('data-color');
          //       if(availableColorList.includes(li_color)){
          //         color_li.classList.remove('disable');
          //       }else{
          //         color_li.classList.add('disable');
          //       }
          //     })
          //   })
          // }
          if (availableCaseTypeList.length > 0) {
            document.querySelectorAll('.filter-type-wrapper').forEach(type_wrapper => {
              type_wrapper.querySelectorAll('li').forEach(type_li => {
                const li_type = type_li.getAttribute('data-type');
                if (availableCaseTypeList.includes(li_type)) {
                  type_li.classList.remove('disable');
                } else {
                  type_li.classList.add('disable');
                }
              })
            })
          }
        }
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // const device_visible_option = document.querySelector('.device_visible_option').innerHTML.trim();
    // const model_visible_option = document.querySelector('.model_visible_option') ? document.querySelector('.model_visible_option').innerHTML.trim() : '';
    const casetype_visible_option = document.querySelector('.casetype_visible_option').innerHTML.trim();
    // if(device_visible_option != '' || model_visible_option != ''){
    //   const filter_wrap =  document.getElementById('main-collection-filters');
    //   filter_wrap.querySelectorAll('details[id^="Details-filter.v.option"]').forEach(details=>{
    //     if(details.id.includes('device')){
    //       details.querySelectorAll('.facets__item').forEach(facet_item => {
    //         if(!(facet_item.getAttribute('data-value').includes(device_visible_option))){
    //           facet_item.classList.add('hidden');
    //         }
    //       })
    //     }else if(details.id.includes('model')){
    //       details.querySelectorAll('.facets__item').forEach(facet_item => {
    //         if(!(facet_item.getAttribute('data-value').includes(model_visible_option))){
    //           facet_item.classList.add('hidden');
    //         }
    //       })
    //     }
    //   })
    // }
    if (casetype_visible_option != '') {
      const filter_wrap = document.getElementById('main-collection-filters');
      filter_wrap.querySelectorAll('details[id^="Details-filter.v.option"]').forEach(details => {
        if (details.id.includes('color')) {
          details.querySelectorAll('.facets__item').forEach(facet_item => {
            if (!(facet_item.getAttribute('data-value').includes(casetype_visible_option))) {
              facet_item.classList.add('hidden');
            }
          })
        }
      })
    }

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {

    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }
      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const hash = window.location.hash || '';
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}${hash}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}
customElements.define('facet-remove', FacetRemove);

class FacetColorWrapper extends HTMLElement {
  constructor() {
    super();
    const facetTarget_list = this.querySelectorAll('a');
    facetTarget_list.forEach(facetTarget => {
      facetTarget.addEventListener('click', this.triggerFilter.bind(this));
      facetTarget.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.triggerFilter(event);
      });
    })
  }

  triggerFilter(event) {
    // event.preventDefault();
    const liItem = event.currentTarget;
    const current_index = Array.from(liItem.parentNode.children).indexOf(liItem);
    const previous_activeItem = document.querySelector('filter-color-wrapper>a.active');
    const previous_index = previous_activeItem ? Array.from(liItem.parentNode.children).indexOf(previous_activeItem) : 0;
    Array.from(liItem.parentNode.children).filter(el => el !== liItem).forEach(item => { item.classList.remove('active') });
    liItem.classList.add('active');
    const data_color = liItem.getAttribute('data-color');
    const t = document.getElementById('product-grid').querySelector(`#${data_color}`).getBoundingClientRect().top + window.scrollY || window.pageYOffset;
    const colorWrapper_h = document.querySelector('#sticky_container>.anchor-facets').clientHeight;
    const header_h = document.querySelector('.section-header').clientHeight;
    const targetTop = current_index > previous_index ? t - colorWrapper_h : t - colorWrapper_h - header_h;
    window.scrollTo({
      top: targetTop,
      behavior: "smooth"
    });
    // document.querySelector('.facets__disclosure[id^="Details-filter.v.option.color"]').querySelectorAll('li.facets__item').forEach(facetsItem => {
    //   const _checkbox = facetsItem.querySelector('input[type="checkbox"]');
    //   const checkbox_value = _checkbox.value;
    //   if((!checkbox_value.includes(data_color) && _checkbox.checked)||(checkbox_value.includes(data_color) && !_checkbox.checked)){
    //     _checkbox.click();
    //   }
    // });
  }
}
customElements.define('filter-color-wrapper', FacetColorWrapper);
